import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
`;

export const SingleCardWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 4px;
`;

export const CardImage = css`
  height: 100%;
  object-fit: cover;
  aspect-ratio: 390 / 108;
`;
